import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { highlightJSON } from '../utils/highlightJSON';
const pageData = {
  $schema: 'https://schema.org/WebPage',
  name: 'Andoe / Switch to Andoe',
  frontmatter: {
    page: 'Switch',
    topic: 'Migration',
    status: 'Active'
  },
  hero: {
    kicker: 'Andoe / Switch',
    headline: 'The way businesses are discovered is changing.',
    lede: 'AI systems now act as an intermediary between businesses and customers. People increasingly rely on AI to understand products, compare options, and make decisions.'
  },
  sections: [{
    ref: '01',
    title: 'The Industry',
    deck: "What's happening in search right now.",
    entries: [{
      ref: '1.1',
      label: 'Shift',
      headline: 'Discovery is moving upstream',
      body: "AI answers questions before people visit a website. If your business doesn't appear clearly in those responses, it may never enter the consideration set."
    }, {
      ref: '1.2',
      label: 'Metrics',
      headline: 'Visibility is no longer just traffic',
      body: "Ranking and publishing more content aren't enough. What matters is how consistently your business is described across prompts, tools, and contexts."
    }, {
      ref: '1.3',
      label: 'Tooling',
      headline: "Existing tools don't show this layer",
      body: "SEO tools track keywords and backlinks. Analytics tools track visits and conversions. They don't show how AI systems understand and describe your business."
    }]
  }, {
    ref: '02',
    title: 'The Problem',
    deck: 'More is not always better.',
    entries: [{
      observation: 'The AI visibility space is evolving quickly with agency-style, SEO-extension, and full-automation approaches.',
      gap: "What's missing is a simpler way to see how AI understands a business and what actions actually matter."
    }, {
      headline: 'Built with product marketers, not around them',
      questions: ['Which prompts actually shape discovery?', "Which ones aren't worth optimizing?", "Where are competitors showing up that you're not?", 'What should you write next, and why?']
    }]
  }, {
    ref: '03',
    title: 'The Switch',
    deck: 'Who switches and how it works.',
    entries: [{
      headline: 'Clarity over volume',
      body: 'Teams switch to Andoe when they realize monitoring is not the same as strategy.'
    }, {
      ref: 'Option 1',
      headline: 'Guided onboarding',
      body: "Book a demo and we'll walk through your current setup together. 7-day free trial of Air plan included."
    }, {
      ref: 'Option 2',
      headline: 'Self-serve setup',
      status: 'coming_soon',
      body: 'Go through the onboarding yourself in minutes. Define what you want to track. Andoe handles the analysis.'
    }]
  }],
  end_cta: {
    label: 'Next',
    headline: 'Ready to switch?',
    body: 'Join the teams moving from noise to clarity.',
    cta: {
      label: 'Book a Demo',
      href: '/contact'
    }
  }
};
export function SwitchPage() {
  const [jsonHtml, setJsonHtml] = useState('');
  useEffect(() => {
    setJsonHtml('<span class="c">// the case for switching, as structured data</span>\n\n' + highlightJSON(pageData));
  }, []);
  return <>
      <Navigation data-id="element-396" />

      <main className="wrap report-main" data-id="element-397">
        <article className="report" data-id="element-398">
          {/* frontmatter */}
          <header className="frontmatter" data-id="element-399">
            <div className="fm-cell" data-id="element-400">
              <span className="lbl" data-id="element-401">Page</span>
              <span className="val" data-id="element-402">Switch</span>
            </div>
            <div className="fm-cell" data-id="element-403">
              <span className="lbl" data-id="element-404">Topic</span>
              <span className="val" data-id="element-405">Migration</span>
            </div>
            <div className="fm-cell" data-id="element-406">
              <span className="lbl" data-id="element-407">Status</span>
              <span className="val" data-id="element-408">Active</span>
            </div>
          </header>

          {/* HERO */}
          <section className="hero" data-id="element-409">
            <div className="kicker" data-id="element-410">Andoe / Switch</div>
            <h1 data-id="element-411">The way businesses are discovered is changing.</h1>
            <p className="lede" data-id="element-412">
              AI systems now act as an intermediary between businesses and
              customers. People increasingly rely on AI to understand products,
              compare options, and make decisions.
            </p>
          </section>

          {/* SECTION 01 */}
          <section className="report-section" data-id="element-413">
            <div className="section-head" data-id="element-414">
              <div className="section-num" data-id="element-415">01</div>
              <div className="section-title" data-id="element-416">
                <h2 data-id="element-417">The Industry</h2>
                <span className="deck" data-id="element-418">
                  What's happening in search right now.
                </span>
              </div>
            </div>
            <div className="section-body" data-id="element-419">
              <div className="pad" data-id="element-420"></div>
              <div className="content" data-id="element-421">
                <div className="entry" data-id="element-422">
                  <div className="entry-label" data-id="element-423">
                    <span className="num" data-id="element-424">1.1</span> Shift
                  </div>
                  <h3 data-id="element-425">Discovery is moving upstream</h3>
                  <p data-id="element-426">
                    AI answers questions before people visit a website. If your
                    business doesn't appear clearly in those responses, it may
                    never enter the consideration set.
                  </p>
                </div>
                <div className="entry" data-id="element-427">
                  <div className="entry-label" data-id="element-428">
                    <span className="num" data-id="element-429">1.2</span> Metrics
                  </div>
                  <h3 data-id="element-430">Visibility is no longer just traffic</h3>
                  <p data-id="element-431">
                    Ranking and publishing more content aren't enough. What
                    matters is how consistently your business is described
                    across prompts, tools, and contexts.
                  </p>
                </div>
                <div className="entry" data-id="element-432">
                  <div className="entry-label" data-id="element-433">
                    <span className="num" data-id="element-434">1.3</span> Tooling
                  </div>
                  <h3 data-id="element-435">Existing tools don't show this layer</h3>
                  <p data-id="element-436">
                    SEO tools track keywords and backlinks. Analytics tools
                    track visits and conversions. They don't show how AI systems
                    understand and describe your business.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* SECTION 02 */}
          <section className="report-section" data-id="element-437">
            <div className="section-head" data-id="element-438">
              <div className="section-num" data-id="element-439">02</div>
              <div className="section-title" data-id="element-440">
                <h2 data-id="element-441">The Problem</h2>
                <span className="deck" data-id="element-442">More is not always better.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-443">
              <div className="pad" data-id="element-444"></div>
              <div className="content" data-id="element-445">
                <div className="entry" data-id="element-446">
                  <p data-id="element-447">
                    The AI visibility space is evolving quickly. Some take a
                    human-in-the-loop, agency-style approach. Others extend
                    traditional SEO tooling into AI contexts. Some promise full
                    automation.
                  </p>
                  <p style={{
                  marginTop: '16px'
                }} data-id="element-448">
                    What's missing is a simpler way to see how AI understands a
                    business and what actions actually matter, without
                    unnecessary layers or jargon.
                  </p>
                </div>
                <div className="entry" data-id="element-449">
                  <h3 data-id="element-450">Built with product marketers, not around them</h3>
                  <p data-id="element-451">
                    Modern product marketing teams already know their customers.
                    They can write, position, launch, and execute using dozens
                    of capable tools. What they don't have is clarity on where
                    to focus.
                  </p>
                  <ul style={{
                  margin: '16px 0',
                  paddingLeft: '20px',
                  color: 'var(--ink-2)',
                  fontSize: '15px'
                }} data-id="element-452">
                    <li data-id="element-453">Which prompts actually shape discovery?</li>
                    <li data-id="element-454">Which ones aren't worth optimizing?</li>
                    <li data-id="element-455">Where are competitors showing up that you're not?</li>
                    <li data-id="element-456">What should you write next, and why?</li>
                  </ul>
                  <p data-id="element-457">
                    There's no new language to learn. Just clear prompt data,
                    competitive comparison, and recommendations that explain
                    what to act on and why.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* SECTION 03 */}
          <section className="report-section" data-id="element-458">
            <div className="section-head" data-id="element-459">
              <div className="section-num" data-id="element-460">03</div>
              <div className="section-title" data-id="element-461">
                <h2 data-id="element-462">The Switch</h2>
                <span className="deck" data-id="element-463">Who switches and how it works.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-464">
              <div className="pad" data-id="element-465"></div>
              <div className="content" data-id="element-466">
                <div className="entry" data-id="element-467">
                  <h3 data-id="element-468">Clarity over volume</h3>
                  <p data-id="element-469">
                    Teams switch to Andoe when they realize monitoring is not
                    the same as strategy. They've used AI visibility tools that
                    surface more data, more prompts, more charts, and more
                    metrics. Dashboards expand. Exports grow. Pricing increases.
                    But the core question remains unanswered.
                  </p>
                  <p style={{
                  marginTop: '16px'
                }} data-id="element-470">
                    They want to know which prompts are worth optimizing, which
                    ones to ignore, where competitors appear and they don't, and
                    what to write next based on actual visibility gaps. They
                    want recommendations grounded in context, not another layer
                    of reporting.
                  </p>
                </div>
                <div className="entry" data-id="element-471">
                  <div className="entry-label" data-id="element-472">
                    <span className="num" data-id="element-473">Option 1</span>
                  </div>
                  <h3 data-id="element-474">Guided onboarding</h3>
                  <p data-id="element-475">
                    Book a demo and we'll walk through your current setup
                    together. We'll also offer a 7-day free trial of our Air
                    plan so you can evaluate Andoe alongside your existing
                    tools.
                  </p>
                </div>
                <div className="entry" data-id="element-476">
                  <div className="entry-label" data-id="element-477">
                    <span className="num" data-id="element-478">Option 2</span>
                  </div>
                  <h3 data-id="element-479">
                    Self-serve setup{' '}
                    <span style={{
                    fontSize: '10px',
                    background: 'var(--rule)',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    marginLeft: '8px'
                  }} data-id="element-480">
                      Coming soon
                    </span>
                  </h3>
                  <p data-id="element-481">
                    Go through the onboarding yourself in minutes. Define what
                    you want to track. Andoe handles the analysis.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* END CTA */}
          <section className="end-cta" id="start" data-id="element-482">
            <div className="end-label" data-id="element-483">Next</div>
            <h2 data-id="element-484">Ready to switch?</h2>
            <p data-id="element-485">Join the teams moving from noise to clarity.</p>
            <Link to="/contact" className="cta" data-id="element-486">
              Book a Demo <span className="arrow" data-id="element-487">→</span>
            </Link>
          </section>

          <Footer data-id="element-488" />
        </article>

        <pre className="json-view" dangerouslySetInnerHTML={{
        __html: jsonHtml
      }} data-id="element-489" />
      </main>
    </>;
}